import { Dialog } from 'primereact/dialog';
import { useEffect, useState, useCallback, useRef } from 'react';
import { Button } from 'primereact/button';
import ContactoAgregarDialog from './ContactoAgregarDialog';
import ContactoEditarDialog from './ContactoEditarDialog';
import { getContactosCliente } from '../../service/AffariService';

const ContactoDialog = ({ visible, onHide, data, onContactosChange }) => {

    const [visibleContactoAgregarDialog, setVisibleContactoAgregarDialog] = useState(false);
    const [visibleContactoEditarDialog, setVisibleContactoEditarDialog] = useState(false);
    const [contactos, setContactos] = useState([]);

    const clienteCodigo = data?.cliente?.codigo;

    const onContactosChangeRef = useRef(onContactosChange);
    const inFlightRef = useRef(false);
    const lastCodigoRef = useRef(null);

    useEffect(() => {
        onContactosChangeRef.current = onContactosChange;
    }, [onContactosChange]);

    const fetchContactos = useCallback(async () => {
        if (!clienteCodigo) return;
        if (inFlightRef.current && lastCodigoRef.current === clienteCodigo) return;

        inFlightRef.current = true;
        lastCodigoRef.current = clienteCodigo;

        try {
            const response = await getContactosCliente(clienteCodigo);
            const lista = Array.isArray(response) ? response : response?.contactos;
            const contactosActualizados = lista ?? [];
            setContactos(contactosActualizados);
            onContactosChangeRef.current?.(contactosActualizados);
        } finally {
            inFlightRef.current = false;
        }
    }, [clienteCodigo]);

    useEffect(() => {
        if (!visible || !clienteCodigo) return;
        fetchContactos();
    }, [visible, clienteCodigo, fetchContactos]);

    const handleAgregar = (e) => {
        e.preventDefault();
        setVisibleContactoAgregarDialog(true);
    };

    const handleEditar = (contacto) => {
        setVisibleContactoEditarDialog(true);
    };

    const handleCancelar = () => {
        onHide();
    };



    return (
        <>
            <Dialog 
                header="Mantenedor de Contactos" 
                visible={visible} 
                className="p-fluid custom-dialog"
                onHide={onHide}
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Cancelar" icon="pi pi-times" onClick={handleCancelar} className="p-button-sm p-button-text p-button-plain" />
                    </div>
                }
            >
                <div className="flex flex-column mb-3">
                    <div className="flex justify-content-between gap-2">
                        <span className="font-medium">Código: {clienteCodigo}</span>
                        <span className="font-medium">Rut: {data?.cliente?.rut}</span>
                    </div>
                    <span className="font-medium">Razón social: {data?.cliente?.razonSocial}</span>
                    <Button label="Agregar" icon="pi pi-plus" className="p-button-sm mt-2" onClick={handleAgregar} />
                </div>

                <div className="flex flex-column gap-2">
                    {contactos?.length ? (
                        contactos.map((contacto) => (
                            <div key={contacto.id ?? `${contacto.nombre}-${contacto.email}`} className="flex align-items-center justify-content-between p-3 border-1 surface-border border-round">
                                <div className="flex flex-column gap-1">
                                    <span className="text-900 font-medium">Razón social: {contacto.nombre}</span>
                                    <span className="text-600 text-sm">Email: {contacto.email}</span>
                                    <span className="text-600 text-sm">Teléfono: {contacto.telefono}</span>
                                </div>
                                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-plain p-button-sm" onClick={() => handleEditar(contacto)} />
                            </div>
                        ))
                    ) : (
                        <span className="text-600 text-sm">No hay contactos.</span>
                    )}
                </div>
            </Dialog>

            <ContactoAgregarDialog visible={visibleContactoAgregarDialog} onHide={setVisibleContactoAgregarDialog} data={data} fetchContactos={fetchContactos} />
            <ContactoEditarDialog visible={visibleContactoEditarDialog} onHide={setVisibleContactoEditarDialog} data={data} fetchContactos={fetchContactos} />
        </>
    );
};

export default ContactoDialog;
